import { render, staticRenderFns } from "./external-income-item.component.html?vue&type=template&id=69823131&"
import script from "./external-income-item.component.ts?vue&type=script&lang=ts&"
export * from "./external-income-item.component.ts?vue&type=script&lang=ts&"
import style0 from "./external-income-item.component.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports